export default __webpack_public_path__ + "static/old-buttons-a52a13a1a6d8f1a0823b92adf3fc9388.png";